import { state } from '@/clickbuy/purchase/store/state';
import { getters } from '@/clickbuy/purchase/store/getters';
import { mutations } from '@/clickbuy/purchase/store/mutations';
import { actions } from '@/clickbuy/purchase/store/action';

export const purchase = {
    state,
    getters,
    actions,
    mutations,
};
